module.exports = __webpack_public_path__ + "static/img/TR.4379c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/TR.png
// module id = q213
// module chunks = 1